// extracted by mini-css-extract-plugin
export default {"container":"CertifiedSecureDigitalPayments_container__ugXEC","cardImages":"CertifiedSecureDigitalPayments_cardImages__50sQK"};